import { useEffect, useRef, useState } from "react";

/**
 * Returns a ref and a boolean indicating whether the element is in view.
 * By default fires once (once the element enters the viewport it stays "true").
 * Pass { once: false } to toggle in and out.
 */
export default function useInView(options = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const once = options.once !== false;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold: options.threshold ?? 0.2, rootMargin: options.rootMargin ?? "0px 0px -10% 0px" }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, inView];
}